import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '../Elements';

import classes from './CompanyIcon.module.scss';

const CompanyIcon = ({ domain }) => {
  // eslint-disable-next-line
  const RE =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)/;
  const website =
    domain && domain.includes('http') ? domain : `http://${domain}`;

  return (
    <div className={classes.logo_wrap}>
      {typeof domain === 'string' && website.match(RE) ? (
        <img
          className={classes.logo}
          src={`https://www.google.com/s2/favicons?domain=${website}`}
          alt=""
          width="16"
          height="16"
        />
      ) : (
        <Icon size="16px" icon={'org'} className={classes.logo} />
      )}
    </div>
  );
};

CompanyIcon.propTypes = {
  domain: PropTypes.string
};

export default CompanyIcon;
